var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningRegular(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.6 23.511L18.67 4.528a3.095 3.095 0 00-5.338 0L2.4 23.51a2.939 2.939 0 000 2.965A3.043 3.043 0 005.07 28h21.862a3.044 3.044 0 002.666-1.524 2.94 2.94 0 00.002-2.965zm-1.733 1.964a1.063 1.063 0 01-.935.525H5.069a1.064 1.064 0 01-.935-.525.949.949 0 010-.965L15.065 5.526a1.093 1.093 0 011.875 0L27.872 24.51a.95.95 0 01-.005.965zM15 18v-5a1 1 0 112 0v5a1 1 0 01-2 0zm2.5 4.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z"
  })));
}
export default SvgWarningRegular;